import { IEnumObject } from "@/shared/constants/enumlist";

export enum EstadoCivil {
  indefinido = 0,
  solteiro = 1,
  casado = 2,
  separado = 3,
  divorciado = 4,
  viuvo = 5,
}

export const EstadosCivisList: IEnumObject[] = [
  { name: '-', value: EstadoCivil.indefinido },
  { name: 'Solteiro', value: EstadoCivil.solteiro },
  { name: 'Casado', value: EstadoCivil.casado },
  { name: 'Separado', value: EstadoCivil.separado },
  { name: 'Divorciado', value: EstadoCivil.divorciado },
  { name: 'Viúvo', value: EstadoCivil.viuvo },
];